const normal = require('./normal');

module.exports = porExtenso;

function porExtenso(numero) {
    return normal(numero) + ' por cento';
}
